export enum NpsSurveyStatus {
  ACCEPTED,
  REJECTED,
}
